import React from 'react';

function VMConfirmModal({
  confirmAction,
  vm,
  vmid,
  actionLoading,
  onCancel,
  onConfirm,
}) {
  return (
    <div className="confirm-overlay" onClick={onCancel}>
      <div className="confirm-modal" onClick={e => e.stopPropagation()}>
        <h3 className="confirm-title">Confirmar: {confirmAction.label}</h3>
        <p className="confirm-desc">{confirmAction.description}</p>
        <p className="confirm-vm">VM: <strong>{vm?.name} (ID {vmid})</strong></p>
        <div className="confirm-actions">
          <button
            className="confirm-btn cancel"
            onClick={onCancel}
          >
            Cancelar
          </button>
          <button
            className={`confirm-btn confirm action-btn ${confirmAction.action === 'stop' ? 'hardstop' : confirmAction.action === 'reset' ? 'hardreset' : confirmAction.action}`}
            onClick={() => onConfirm(confirmAction.action)}
            disabled={actionLoading}
          >
            Confirmar {confirmAction.label}
          </button>
        </div>
      </div>
    </div>
  );
}

export default VMConfirmModal;
